'use client';

import { sendGAEvent } from '@next/third-parties/google';
import { useState } from 'react';
import { reportContent } from '@/app/actions/public-actions';

interface ShareWidgetProps {
    title: string;
    slug: string;
    contentId: number;
}

export default function ShareWidget({ title, slug, contentId }: ShareWidgetProps) {
    const [reportState, setReportState] = useState<{ pending: boolean; message: string }>({ pending: false, message: '' });

    const handleShare = (method: string) => {
        // Construct URL
        const url = `${window.location.origin}/${slug}`;

        let shareUrl = '#';
        if (method === 'facebook') shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        if (method === 'twitter') shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
        if (method === 'linkedin') shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        if (method === 'email') shareUrl = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;

        // Track
        sendGAEvent('event', 'share', {
            method: method,
            content_type: 'article',
            item_id: slug,
        });

        if (method !== 'email') {
            window.open(shareUrl, '_blank', 'width=600,height=400');
        } else {
            window.location.href = shareUrl;
        }
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            <button onClick={() => handleShare('facebook')} className="btn btn-outline bg-[var(--color-bg-base)] text-[var(--color-text-base)]" style={{ fontSize: '12px', padding: '8px' }}> Facebook </button>
            <button onClick={() => handleShare('twitter')} className="btn btn-outline bg-[var(--color-bg-base)] text-[var(--color-text-base)]" style={{ fontSize: '12px', padding: '8px' }}> X (Twitter) </button>
            <button onClick={() => handleShare('linkedin')} className="btn btn-outline bg-[var(--color-bg-base)] text-[var(--color-text-base)]" style={{ fontSize: '12px', padding: '8px' }}> LinkedIn </button>
            <button onClick={() => handleShare('email')} className="btn btn-outline bg-[var(--color-bg-base)] text-[var(--color-text-base)]" style={{ fontSize: '12px', padding: '8px' }}> Email </button>
            <button
                onClick={async () => {
                    if (reportState.pending) return;
                    setReportState({ pending: true, message: '' });
                    const res = await reportContent(contentId);
                    if (!res.success) {
                        setReportState({ pending: false, message: res.error || 'Unable to report.' });
                        return;
                    }
                    setReportState({
                        pending: false,
                        message: res.alreadyReported ? 'Already reported.' : 'Reported.',
                    });
                }}
                className="btn btn-outline bg-[var(--color-bg-base)] text-[var(--color-text-base)]"
                style={{ fontSize: '12px', padding: '8px', gridColumn: '1 / -1' }}
                disabled={reportState.pending}
            >
                {reportState.pending ? 'Reporting...' : 'Report'}
            </button>
            {reportState.message ? (
                <div style={{ gridColumn: '1 / -1', fontSize: '12px', color: 'var(--color-text-muted)' }}>
                    {reportState.message}
                </div>
            ) : null}
        </div>
    );
}
